import { useAiChatAttached } from '@euler/app/flows/ai-suite/chat/AiChatActions';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useState } from 'react';
import { View } from 'react-native';
import { ProposalTile } from './ProposalTile';
import { BiProposalSelection } from './functions/useBiProposalSelection';

/** From this width the previews sit two to a row. */
const kTwoColumnsFrom = 520;

/** Proposals as small previews, best first, each with its checkbox. */
export const BiProposalTiles = memo(
  ({
    draftIds,
    selection,
  }: {
    draftIds: string[];
    selection: BiProposalSelection;
  }) => {
    const { rpx } = useResponsiveContext();
    const attached = useAiChatAttached();
    const [width, setWidth] = useState(0);
    const gap = rpx(10);
    const columns = width >= kTwoColumnsFrom ? 2 : 1;
    const tileWidth = columns === 2 ? (width - gap) / 2 : width;
    return (
      <View
        onLayout={event => setWidth(event.nativeEvent.layout.width)}
        style={{ flexDirection: 'row', flexWrap: 'wrap', gap }}
      >
        {width
          ? draftIds.map(draftId => (
              <View key={draftId} style={{ width: tileWidth }}>
                <ProposalTile
                  draftId={draftId}
                  selectable={attached}
                  selected={selection.selected.includes(draftId)}
                  onToggle={() => selection.toggle(draftId)}
                />
              </View>
            ))
          : null}
      </View>
    );
  },
);
